import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Modal, ModalBody, Button } from '../../../Components/ui';
import CustomTable from '../../../Components/Common/Table';
import { API, BACKEND_HOST } from '../../../api';
import UsageSection from '../../../Components/B2Busage';
import { dialogService } from "@/utils/dialogService";
export default function CouponList() {
    const navigate = useNavigate();
    const [data, setData] = React.useState([]);
    const [delRecord, setDelRecord] = React.useState<number | null>(null);
    const [modalDelete, setModalDelete] = React.useState(false);
    const [shareRecord, setShareRecord] = React.useState(null);
    const [modalShare, setModalShare] = React.useState(false);
    const handleEdit = useCallback((id: number) => {
        navigate(`/coupon-form/${id}`);
    }, [navigate]);
    const handleManageDistribution = useCallback((id: number) => {
        navigate(`/coupon-form/${id}?tab=book`);
    }, [navigate]);
    const handleCopy = useCallback((id: number) => {
        navigate(`/coupon-form/${id}?copy=true`);
    }, [navigate]);
    const handleDelete = useCallback((id: number) => {
        setDelRecord(id);
        setModalDelete(true);
    }, []);
    const columns = React.useMemo(() => [
        { Header: "ID", accessor: "id" },
        { Header: "title", accessor: "title" },
        { Header: "expire_date", accessor: "expire_date" },
        { Header: "state", accessor: "state" },
        { Header: "bound_type", accessor: "bound_type" },
        { Header: "discount_type", accessor: "discount_type" },
        {
            Header: '관리',
            accessor: 'actions',
            Cell: ({ row }: any) => {
                const id = row.original.id;
                return (<div className="d-flex gap-2">
						<Button onClick={() => handleManageDistribution(id)} color="primary" size="sm" className="edit-item-btn">배포설정</Button>
						<Button onClick={() => handleEdit(id)} color="success" size="sm" className="edit-item-btn">수정</Button>
						<Button onClick={() => handleCopy(id)} color="info" size="sm" className="copy-item-btn">복사</Button>
						<Button onClick={() => handleDelete(id)} color="danger" size="sm" className="remove-item-btn">삭제</Button>
					</div>);
            }
        }
    ], [handleManageDistribution, handleEdit, handleCopy, handleDelete]);
    function fetchData() {
        API.get(`${BACKEND_HOST}/coupon/products?include_hidden=true`)
            .then((res) => {
            const rows = Array.isArray(res.data) ? res.data : res.data?.results ?? [];
            setData(rows);
        })
            .catch(e => console.log(e));
    }
    React.useEffect(() => {
        fetchData();
    }, []);
    const deleteRecord = () => {
        API.delete(`${BACKEND_HOST}/coupon/products/${delRecord}/`)
            .then(async (res) => {
            await dialogService.handleAlert("Delete ok!");
            setModalDelete(false);
            fetchData();
        })
            .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
    };
    return (<React.Fragment>
			<div className="page-content">
				<div className="container-fluid">
					<BreadCrumb title="쿠폰목록" pageTitle="쿠폰"/>
					<div className="flex flex-wrap -mx-3">
						<div className="w-full px-3">
							<div className="card">
								<div className="card-header d-flex align-items-center justify-content-between">
									<h4 className="card-title mb-0 flex-grow-1">쿠폰 목록</h4>
									<div>
										<Button onClick={() => { navigate(`/coupon-form/${0}`); }} id="create-btn" color="success" className="add-btn me-1"><i className="ri-add-line align-bottom me-1"></i> 생성</Button>
									</div>
								</div>

								<div className="card-body">
									<UsageSection productType="coupon"/>
									<CustomTable data={data} columns={columns} onClickSort={undefined}/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Remove Modal */}
			<Modal isOpen={modalDelete} onClose={() => setModalDelete(false)}>
				<ModalBody className="text-center p-5">
					<div className="mt-4">
						<h4 className="mb-3">Are you Sure ?</h4>
						<p className="text-muted mb-4">{`Are you Sure You want to Remove this Record(id:${delRecord}) ?`}</p>
						<div className="hstack gap-2 justify-content-center">
							<Button onClick={() => { setDelRecord(null); setModalDelete(false); }} color="light">Cancel</Button>
							<Button onClick={deleteRecord} color="danger">Delete</Button>
						</div>
					</div>
				</ModalBody>
			</Modal>

			{/* Share Link Modal */}
			<Modal isOpen={modalShare} onClose={() => setModalShare(false)}>
				<ModalBody className="text-center p-5">
					<div className="mt-4">
						<h4 className="mb-3">공유 링크</h4>
						<p className="text-muted mb-4">아래 링크를 복사하여 공유하세요.</p>
						<div className="hstack gap-2 justify-content-center">
							<input type="text" className="form-control" value={shareRecord}/>
							<Button onClick={() => { setModalShare(false); }} color="light">Close</Button>
						</div>
					</div>
				</ModalBody>
			</Modal>

		</React.Fragment>);
}
